import { Box } from "@mui/material";
import React from "react";

const VerticalNavLayout = (props) => {
  return <Box sx={{ display: "flex", flexGrow: 1, height: "100%" }}>{props.children}</Box>;
};

export default VerticalNavLayout;
